import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { appContentUrl, storageKeys } from 'settings';
import { APIHandler, DataHandler, StorageHandler } from 'C4';
import { toast, cssTransition } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const trackShare = (type, value) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'Guest';
      if (userObj && userObj.response) {
        ({ email } = userObj.response);
      }
      APIHandler.trackEvent(appId, email, 'collateral', type, value).then(() => {
      });
    });
  });
};

export default class LinkHandler extends Component {
  constructor(props) {
    super(props);

    this.state = {
      graduate: false,
    };

    this.ChooseFavoritesLinkBehaviour = this.ChooseFavoritesLinkBehaviour.bind(this);
    this.ChooseSellPromoteBehaviour = this.ChooseSellPromoteBehaviour.bind(this);
  }

  componentDidMount() {
    this.setGraduateStatus();
  }

  setGraduateStatus() {
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res && res.response) {
        if (typeof res.response.training_graduated === 'undefined' || res.response.training_graduated === null) {
          this.setState({ graduate: false });
        } else {
          this.setState({ graduate: true });
        }
      }
    });
  }

  ChooseSellPromoteBehaviour() {
    const {
      appId,
      url,
      type,
      UniqueID,
      className,
      children,
      title,
      dataOptions,
      dataFancybox,
      dataTrigger,
      page,
    } = this.props;

    const { graduate } = this.state;
    const objectUrl = `${appContentUrl}${appId}/${typeof url === 'object' ? url[0] : url}`;
    const parsedTitle = title.toLowerCase().replace(/ /g, '-');
    const pageNames = { f: 'promote', t: 'sell' };

    // eslint-disable-next-line default-case
    switch (url) {
      case 'videos':
        return <Link onClick={() => trackShare('carousel', parsedTitle)} to={`/main/${pageNames[page]}/${parsedTitle}`} key={UniqueID} className={className}>{children}</Link>;
      case 'https://travpro.yourworldapps.nl/directory/bvi_dir/map/map.php?app_id=43':
        return <a onClick={() => trackShare('web', url)} data-fancybox={UniqueID} data-type="iframe" data-options={dataOptions} data-src={url} href={url} key={UniqueID} className={className}>{children}</a>;
      case 'https://travpro.yourworldapps.nl/directory/bvi_dir/map/map.php?app_id=258':
        return <a onClick={() => trackShare('web', url)} data-fancybox={UniqueID} data-type="iframe" data-options={dataOptions} data-src={url} href={url} key={UniqueID} className={className}>{children}</a>;
    }

    // if (parsedTitle === 'virtual-escapes') {
    //   return <Link onClick={() => trackShare('carousel', parsedTitle)} to={`/main/${pageNames[page]}/${parsedTitle}`} key={UniqueID} className={className}>{children}</Link>;
    // }

    // if (parsedTitle === 'covid-protocols') {
    //   return <Link onClick={() => trackShare('carousel', parsedTitle)} to={`/main/${pageNames[page]}/${parsedTitle}`} key={UniqueID} className={className}>{children}</Link>;
    // }

    if (parsedTitle === 'specialist-perks') {
        if (!graduate) {
          return <div key={UniqueID} className={`${className} lockedTile`}><div className="locked">Unlock this tile by becoming a BVI Revealed Specialist</div>{children}</div>;
        }
        return <Link onClick={() => trackShare('carousel', parsedTitle)} to={`/main/${pageNames[page]}/${parsedTitle}`} key={UniqueID} className={className}>{children}</Link>;
    }


    switch (type) {
      case 'coming_soon':
        return <a key={UniqueID} className={className}>{children}</a>;
      case 'image_library':
        return <Link onClick={() => trackShare('carousel', parsedTitle)} to={`/main/${pageNames[page]}/${url}`} key={UniqueID} className={className}>{children}</Link>;
      case 'video_library':
        return <Link onClick={() => trackShare('carousel', parsedTitle)} to={`/main/${pageNames[page]}/${url}`} key={UniqueID} className={className}>{children}</Link>;
      case 'carousel':
      case 'collection':
        return <Link onClick={() => trackShare('carousel', url)} to={`/main/${pageNames[page]}/${parsedTitle}`} key={UniqueID} className={className}>{children}</Link>;
      case 'weblink':
        return <a onClick={() => trackShare('web', url)} href={url} key={UniqueID} target="_blank" rel="noreferrer noopener" className={className}>{children}</a>;
      case 'iframe':
        return <a onClick={() => trackShare('web', url)} data-fancybox={UniqueID} data-type="iframe" data-options={dataOptions} data-src={url} href={url} key={UniqueID} className={className}>{children}</a>;
      case 'contact':
        return <Link onClick={() => trackShare('contact', 'contact')} to="/main/promote/contact" key={UniqueID} className={className}>{children}</Link>;
      case 'contact_us':
        return <Link onClick={() => trackShare('contact', 'contact')} to="/main/promote/contact" key={UniqueID} className={className}>{children}</Link>;
      case 'directory':
        return <Link onClick={() => trackShare('directory', url)} to="/main/directory" key={UniqueID} className={className}>{children}</Link>;
      case 'infographic':
        return <div onClick={() => trackShare('infographic', url)} data-src={url} data-fancybox={dataFancybox} data-options={dataOptions} data-fancybox-trigger={dataTrigger} className={className} key={UniqueID}>{children}</div>;
      case 'brochure':
        return <div onClick={() => trackShare('collection', parsedTitle)} data-src={url} data-fancybox={dataFancybox} data-options={dataOptions} data-fancybox-trigger={dataTrigger} className={className} key={UniqueID}>{children}</div>;
      case 'image':
        return <div onClick={() => trackShare('image', url)} data-src={url} data-fancybox={dataFancybox} data-options={dataOptions} data-fancybox-trigger={dataTrigger} className={className} key={UniqueID}>{children}</div>;
      case 'pdf':
        return <div onClick={() => trackShare('pdf', url)} data-src={`https://stack.travpromobile.com/viewer.php?file=${url}`} data-fancybox={dataFancybox} data-options={dataOptions} data-fancybox-trigger={dataTrigger} className={className} key={UniqueID}>{children}</div>;
      case 'multi':
        return <div onClick={() => trackShare('multi', url)} data-fancybox={UniqueID} data-fancybox-trigger={UniqueID} data-src={`#${UniqueID}`} className={className} key={UniqueID}>{children}</div>;
      default:
        return <a onClick={() => trackShare(url, url)} href={url} data-options={dataOptions} data-fancybox={dataFancybox} data-fancybox-trigger={dataTrigger} target="" className={className} key={UniqueID}>{children}</a>;
    }
  }

  ChooseFavoritesLinkBehaviour() {
    const {
      appId,
      url,
      type,
      subType,
      UniqueID,
      className,
      children,
      dataOptions,
      dataFancybox,
      dataTrigger,
    } = this.props;

    const { chapter, page } = this.props.info;

    const objectUrl = `${appContentUrl}${appId}/${typeof url === 'object' ? url[0] : url}`;

    // t = Promote or Sell item
    if (type === 't') {
      switch (subType) {
        case 'image_library':
          return <Link onClick={() => trackShare('carousel', url)} to={`sell/${url}`} key={UniqueID} className={className}>{children}</Link>;
        case 'video_library':
          return <Link onClick={() => trackShare('carousel', url)} to={`sell/${url}`} key={UniqueID} className={className}>{children}</Link>;
        case 'weblink':
          return <a onClick={() => trackShare('web', url)} href={url} key={UniqueID} target="_blank" rel="noreferrer noopener" className={className}>{children}</a>;
        case 'coming_soon':
          return <a href="#" key={UniqueID} className={className}>{children}</a>;
        case 'iframe':
          return <a onClick={() => trackShare('iframe', url)} data-fancybox={UniqueID} data-type="iframe" data-options={dataOptions} data-src={url} href={url} key={UniqueID} className={className}>{children}</a>;
        case 'contact':
          return <Link onClick={() => trackShare('contact', 'contact')} to="/main/promote/contact" key={UniqueID} className={className}>{children}</Link>;
        case 'directory':
          return <Link onClick={() => trackShare('directory', url)} to="/main/directory" key={UniqueID} className={className}>{children}</Link>;
        case 'infographic':
          return <div onClick={() => trackShare('infographic', url)} data-src={url} data-fancybox={dataFancybox} data-options={dataOptions} data-fancybox-trigger={dataTrigger} className={className} key={UniqueID}>{children}</div>;
        case 'brochure':
          return <div onClick={() => trackShare('carousel', url)} data-src={url} data-fancybox={dataFancybox} data-options={dataOptions} data-fancybox-trigger={dataTrigger} className={className} key={UniqueID}>{children}</div>;
        case 'image':
          return <div onClick={() => trackShare('image', url)} data-src={url} data-fancybox={dataFancybox} data-options={dataOptions} data-fancybox-trigger={dataTrigger} className={className} key={UniqueID}>{children}</div>;
        case 'multi':
          return <div onClick={() => trackShare('multi', url)} data-fancybox={UniqueID} data-fancybox-trigger={UniqueID} data-src={`#${UniqueID}`} className={className} key={UniqueID}>{children}</div>;
        default:
          return <a onClick={() => trackShare(url, url)} href={url} data-options={dataOptions} data-fancybox={dataFancybox} data-fancybox-trigger={dataTrigger} target="" className={className} key={UniqueID}>{children}</a>;
      }
    }
    // p = Training Content Page
    if (type === 'p') {
      return <Link to={`ret/chapter/${chapter}/${page - 1}`} className="favorite__button" key={UniqueID}>{children}</Link>;
    }
    return null;
  }

  render() {
    const { favorites } = this.props;
    return (
      <React.Fragment>
        {favorites ? this.ChooseFavoritesLinkBehaviour() : this.ChooseSellPromoteBehaviour()}
      </React.Fragment>
    );
  }
}

LinkHandler.propTypes = {
  info: PropTypes.shape({
    chapter: PropTypes.string,
    page: PropTypes.string,
  }),
  appId: PropTypes.number,
  url: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  type: PropTypes.string.isRequired,
  subType: PropTypes.string,
  title: PropTypes.string.isRequired,
  UniqueID: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  dataOptions: PropTypes.string.isRequired,
  dataFancybox: PropTypes.string.isRequired,
  dataTrigger: PropTypes.string.isRequired,
  favorites: PropTypes.bool,
};

LinkHandler.defaultProps = {
  info: {},
  subType: 't',
  appId: -1,
  url: '#',
  favorites: false,
};

